import React, { useState } from "react";
import DeveloperPlan from "./components/DeveloperPlan";
import { useUsersContext } from "../../../../context/usersContext";
import PricingPlanCard from "./components/PricingPlanCard";
import PricingFooter from "./components/PricingFooter";
import { useUserInfo } from "../../../../context/user";
import CancelModal from "../Balance/component/CancelModal";
import CancelConfirmModal from "../Balance/component/CancelConfirmModal";

const Pricing = ({ limit, pricingHeading, setActiveTab }) => {
  const { products, agency } = useUsersContext();
  const [planType, setPlanType] = useState("monthly");
  const userActiveLocation = useUserInfo()[4]
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);


  return (
    // <>
    //   {userActiveLocation.business_type === 'Developer' ? (
    //     <DeveloperPlan setShowDeveloperPlan={setShowDeveloperPlan} setActiveTab={setActiveTab} />
    //   ) : (
    <>
      {/* {developerPlans?.length > 0 && <p
            onClick={() => setShowDeveloperPlan(true)}
            className="flex float-end pb-4 underline font-medium cursor-pointer"
          >
            Are you a Developer?
          </p>} */}

      <div className="page-header [&_.page-display]:text-3xl [&_.page-display]:md:text-4xl [&_.page-lede]:text-sm pb-4">
        <span className="page-eyebrow">Plans</span>
        {userActiveLocation?.account_type === "Developer" ? (
          <h1 className="page-display">
            Developer Plan.{" "}
            <span className="accent block md:inline">
              Choose the perfect plan for your needs.
            </span>
          </h1>
        ) : pricingHeading ? (
          <h1 className="page-display">{pricingHeading}</h1>
        ) : (
          <>
            <h1 className="page-display">
              {agency?.pricing_page_headline ? (
                agency.pricing_page_headline
              ) : (
                <>
                  Plans.{" "}
                  <span className="accent block md:inline">
                    Your plan &amp; upgrade options.
                  </span>
                </>
              )}
            </h1>
            <p className="page-lede">
              Manage your subscription, team members, and Task usage. Every
              plan includes the full Agent library, your connected tools, and
              unlimited delegation.
            </p>
          </>
        )}
      </div>

      <div className="mb-8 flex justify-start">
        <div
          role="tablist"
          aria-label="Billing cycle"
          className="relative inline-grid grid-cols-2 items-center rounded-xl border border-border bg-muted/40 p-1"
        >
          <span
            aria-hidden
            className={`absolute top-1 bottom-1 left-1 w-[calc(50%-0.25rem)] rounded-lg bg-foreground shadow-sm transition-transform duration-300 ${planType === "yearly" ? "translate-x-[calc(100%+0.25rem)]" : ""
              }`}
          />
          <button
            type="button"
            role="tab"
            aria-selected={planType === "monthly"}
            onClick={() => setPlanType("monthly")}
            className={`relative z-10 px-5 h-9 rounded-lg text-xs font-semibold tracking-wide transition-colors ${planType === "monthly"
                ? "text-background"
                : "text-muted-foreground hover:text-foreground"
              }`}
          >
            Pay monthly
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={planType === "yearly"}
            onClick={() => setPlanType("yearly")}
            className={`relative z-10 px-5 h-9 rounded-lg text-xs font-semibold tracking-wide transition-colors ${planType === "yearly"
                ? "text-background"
                : "text-muted-foreground hover:text-foreground"
              }`}
          >
            Pay yearly.{" "}
            <span
              className={
                planType === "yearly"
                  ? "text-background/80"
                  : "text-[hsl(var(--task-accent))]"
              }
            >
              Save 17.5%
            </span>
          </button>
        </div>
      </div>

      <div
        data-testid="plan-matrix"
        className="my-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 rounded-2xl border border-border bg-card overflow-hidden [&>*]:border-border max-md:[&>*:not(:first-child)]:border-t md:max-lg:[&>*:nth-child(even)]:border-l md:max-lg:[&>*:nth-child(n+3)]:border-t lg:[&>*:not(:nth-child(4n+1))]:border-l lg:[&>*:nth-child(n+5)]:border-t"
      >
        {products
          ?.filter((product) => { if (userActiveLocation.account_type === 'Developer') { return product?.developer_plan === true } else { return product?.isenable_account === true } })
          ?.sort((a, b) => {
            const priceA =
              planType === "monthly"
                ? a.monthly_amount || 0
                : a.yearly_amount || 0;
            const priceB =
              planType === "monthly"
                ? b.monthly_amount || 0
                : b.yearly_amount || 0;
            return priceA - priceB;
          })
          ?.map((product) => (
            <PricingPlanCard
              data={product}
              key={product?._id}
              planType={planType}
              setActiveTab={setActiveTab}
              agency={agency}
              setOpenCancelModal={setOpenCancelModal}
            />
          ))}
      </div>
      <div className="text-center mt-10">
        <p className="text-sm text-muted-foreground">
          {agency?.pricing_page_message || ""}
        </p>
      </div>
      <PricingFooter />

      {openCancelModal && (
        <CancelModal
          isOpen={openCancelModal}
          onClose={() => {
            setOpenCancelModal(false);
          }}
          setOpenConfirmModal={setOpenConfirmModal}
        />
      )}
      {openConfirmModal && (
        <CancelConfirmModal
          isOpen={openConfirmModal}
          onClose={() => setOpenConfirmModal(false)}
        />
      )}
    </>
  );
};

export default Pricing;
